import { render, staticRenderFns } from "./VerAlertaBaseModal.vue?vue&type=template&id=3283dc61&"
import script from "./VerAlertaBaseModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports